import { request } from "@/service/request.js";

export function applyInvoice(options) {
  return request.call(this, {
      url: "/openapi/web/invoice/apply",
      method: 'POST',
      data:options
  });
};

// 失败重试
export function InvoiceRetry(options) {
  return request.call(this, {
    url: "/openapi/web/invoice/errHandle",
    method: 'POST',
    data: options
  });
};

// 修改发票名头重开
export function InvoiceReApply(options) {
  return request.call(this, {
    url: "/openapi/web/invoice/reApply",
    method: 'POST',
    data: options
  });
};
